import { render, staticRenderFns } from "./clubIndex.vue?vue&type=template&id=40998e64&scoped=true"
import script from "./clubIndex.vue?vue&type=script&lang=js"
export * from "./clubIndex.vue?vue&type=script&lang=js"
import style0 from "./clubIndex.vue?vue&type=style&index=0&id=40998e64&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40998e64",
  null
  
)

export default component.exports